import React, { useEffect, useRef, useState } from "react";
import { FaCamera, FaMicrophone, FaVideoSlash } from "react-icons/fa";
import { FaBell, FaCommentAlt, FaHeart, FaShare, FaSearch, FaChevronDown } from "react-icons/fa";
import Leftsidebar from "../components/sidebar/leftsidebar"
import LeftResponsivesidebar from "../components/sidebar/left-responsive"
import Rightsidebar from "../components/sidebar/rightsidebar"
import Headmenu from "../components/sidebar/headmenu"
import videoslash from "../assets/images/icons/video-slash.png";
import cameraoff from "../assets/images/icons/camera-off.png";
import golivecam from "../assets/images/icons/golive-cam.png";
import global from "../assets/images/icons/global.png";
import profileimg from "../assets/profile.png";
import like from "../assets/images/icons/like.png";
import golivebanner from "../assets/images/golive-prf.png";
export default function Golive() {
    const [commentsEnabled, setCommentsEnabled] = useState(false);
    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };
    // ✅ Define state properly
    const [isOpen, setIsOpen] = useState(false);

    const [isLive, setIsLive] = useState(false); // Tracks Go Live state
    const [cameraStream, setCameraStream] = useState(null);
    const [cameraError, setCameraError] = useState(false); // Tracks camera errors
    const [chatMessages, setChatMessages] = useState([]);
    const videoRef = useRef(null);
    // Dummy chat data for when live
    const liveChatMessages = [
        { id: 1, name: "Ralph Edwards", time: "12:20 PM", message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. " },
        { id: 2, name: "Ralph Edwards", time: "12:21 PM", message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. " },
        { id: 3, name: "Ralph Edwards", time: "12:22 PM", message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. " },
        { id: 4, name: "Ralph Edwards", time: "12:20 PM", message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. " },
        { id: 5, name: "Ralph Edwards", time: "12:21 PM", message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. " },
        { id: 6, name: "Ralph Edwards", time: "12:22 PM", message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. " },
        { id: 7, name: "Ralph Edwards", time: "12:20 PM", message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. " },
        { id: 8, name: "Ralph Edwards", time: "12:21 PM", message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. " },
        { id: 9, name: "Ralph Edwards", time: "12:22 PM", message: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. " },

    ];


    // Function to start the camera
    const startCamera = async () => {
        setCameraError(false); // ✅ Reset error state before retrying

        try {
            const permissions = await navigator.permissions.query({ name: 'camera' });
            if (permissions.state === 'denied') {
                alert(
                    "Camera access is blocked. Follow these steps:\n" +
                    "1. Click the lock icon next to the URL in your browser.\n" +
                    "2. Find 'Camera' in the list and change it to 'Allow'.\n" +
                    "3. Refresh the page and click 'Go Live'."
                );
                return; // Prevent further execution
            }

            const stream = await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: false,
            });

            setCameraStream(stream);
            setIsLive(true);
            setChatMessages(liveChatMessages);

            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }
        } catch (error) {
            console.error("Error accessing the camera:", error);
            setCameraError(true);
        }
    };


    const stopCamera = () => {
        if (cameraStream) {
            cameraStream.getTracks().forEach((track) => track.stop());
            setCameraStream(null);
        }
        setIsLive(false);
        setChatMessages([]);
    };
    // Function to toggle live state
    const handleGoLive = () => {
        if (isLive) {
            stopCamera(); // Stop camera if live
        } else {
            startCamera(); // Start camera if not live
        }
    };

    return (

        <div className="dashboard w-full min-h-screen  flex">
            {/* Sidebar */}
            <Leftsidebar />
            <main className="flex-1 p-6 go-live">
                <div className="px-6 pt-6 navbar-golive">
                    <LeftResponsivesidebar />
                    <Headmenu />
                </div>
                {/* <LeftResponsivesidebar />
                <Headmenu /> */}
                {/* Main Content */}
                <main className="row flex items-stretch golivresponsive">
                    <div className="flex-1 lg:pr-5 space-y-6">
                        {/* GoLive Content */}
                        <div className="pt-0">
                            {/* Add Title Input */}
                            <div className="add-title-golive">
                                <input
                                    type="text"
                                    placeholder="Add Title..."
                                    className="w-full p-3 border border-[#095228] rounded-full mb-4 go-live-add-title"
                                /></div>
                            <div className="bg-green-100 golive-body">

                                {/* Camera Screen Placeholder */}
                                <div className="bg-black text-white flex flex-col items-center justify-center camera relative h-[500px]">
                                    {cameraStream ? (
                                        <div className="">
                                            <div className="absolute top-9 left-0 bg-[#ffffff73] profile-img">
                                                <div className="flex p-2 pl-5 items-center">
                                                    {/* Profile Image Inside Textarea */}
                                                    <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                                                        <img src={profileimg} alt="Profile" className="w-full h-full object-cover" />
                                                    </div>
                                                    <div className="feed-title pl-4">
                                                        <p className="font-semibold text-[#000]">
                                                            Praveen Krishnamoorthy
                                                        </p>
                                                        <p className="flex text-sm text-[#000]">
                                                            27 Jan 2025, 12:30 PM
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <video
                                                ref={videoRef}
                                                autoPlay
                                                playsInline
                                                className="w-full h-full object-cover"
                                            />
                                            {/* Show Like Button only when live */}
                                            {isLive && (
                                                <button className=" text-white px-5 mx-2 py-1 rounded-[20px] absolute left-3 bottom-5">
                                                    100K Viewers
                                                </button>
                                            )}
                                            {/* Show Like Button only when live */}
                                            {isLive && (
                                                <button className="bg-[#BE1F2E] text-white px-5 mx-2 py-1 rounded-[20px] absolute right-3 bottom-5">
                                                    LIVE
                                                </button>
                                            )}
                                        </div>
                                    ) : cameraError ? (
                                        <>
                                            <div className="absolute top-9 left-0 bg-[#ffffff73] profile-img">
                                                <div className="flex p-2 pl-5 items-center">
                                                    {/* Profile Image Inside Textarea */}
                                                    <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                                                        <img src={profileimg} alt="Profile" className="w-full h-full object-cover" />
                                                    </div>
                                                    <div className="feed-title pl-4">
                                                        <p className="font-semibold text-[#000]">
                                                            Praveen Krishnamoorthy
                                                        </p>
                                                        <p className="flex text-sm text-[#000]">
                                                            27 Jan 2025, 12:30 PM
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <img src={golivecam} alt="Go Live Camera" />
                                            <p className="text-lg font-semibold">Allow Access To Camera</p>
                                            <p className="text-sm text-gray-400 px-8 text-center">
                                                Your Browser Is Not Allowing Live Producer Access To Your Camera.
                                                Go To Your Browser Settings And Allow Camera Permission.
                                            </p>
                                            <button
                                                className="mt-4 px-6 py-2 bg-[#D9D9D9] text-[#000000] font-semibold rounded-xl"
                                                onClick={startCamera}  // ✅ Calls updated function
                                            >
                                                Retry
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <div
                                                className="relative bg-cover bg-center h-[500px] w-full camera text-center"
                                                style={{ backgroundImage: `url(${golivebanner})` }} // ✅ Dynamic Banner Image
                                            >
                                                <div className="absolute top-9 left-0 bg-[#ffffff73] profile-img">
                                                    <div className="flex p-2 pl-5 items-center">
                                                        {/* Profile Image Inside Textarea */}
                                                        <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                                                            <img src={profileimg} alt="Profile" className="w-full h-full object-cover" />
                                                        </div>
                                                        <div className="feed-title pl-4">
                                                            <p className="font-semibold text-[#000]">
                                                                Praveen Krishnamoorthy
                                                            </p>
                                                            <p className="flex text-sm text-[#000]">
                                                                27 Jan 2025, 12:30 PM
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                                {/* Controls */}
                                <div className="golive-controls flex items-center justify-between p-4 rounded-lg">
                                    <div className="flex space-x-4">
                                        <button className="p-5 bg-[#FFFFFF80] rounded-full shadow-md cam-off">
                                            <img src={cameraoff} className="w-5" />
                                        </button>
                                        <button className="p-5 bg-[#FFFFFF80] rounded-full shadow-md cam-off">
                                            <img src={videoslash} className="w-5" />
                                        </button>

                                        {/* Toggle Switch */}
                                        <label className="inline-flex items-center cursor-pointer relative toggle-golive">
                                            <input
                                                type="checkbox"
                                                className="sr-only peer"
                                                checked={commentsEnabled}
                                                onChange={() => setCommentsEnabled(!commentsEnabled)}
                                            />
                                            <div className={`relative w-14 h-8 bg-[#095228] rounded-full peer-checked:bg-[#161F28] ${commentsEnabled ? 'bg-[#095228]' : 'bg-[#161F28]'}`}>
                                                {/* Knob */}
                                                <div
                                                    className={`absolute top-[3px] left-[5px] w-6 h-6 bg-white border border-[#161F28] rounded-full transition-all ${commentsEnabled ? 'translate-x-full' : ''
                                                        }`}
                                                />
                                                {/* Single Span for ON/OFF */}
                                                <span
                                                    className={`absolute text-xs text-white top-4 transform -translate-y-1/2 
                                                ${commentsEnabled ? 'left-2' : 'left-8'}`}
                                                >
                                                    {commentsEnabled ? 'ON' : 'OFF'}
                                                </span>
                                            </div>
                                            <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300 ">
                                                Comments
                                            </span>
                                        </label>
                                    </div>
                                    <div className="flex items-center space-x-4">
                                        <div className="relative hidden md:block">
                                            <button
                                                onClick={toggleDropdown}
                                                className="share-public flex items-center px-4 py-2"
                                            >
                                                <img src={global} alt="Globe" className="pr-2" />
                                                Public
                                                <FaChevronDown className="ml-2 text-xs text-gray-400" />
                                            </button>

                                            {/* ✅ Show dropdown only if isOpen is true */}
                                            {isOpen && (
                                                <div className="absolute top-12 left-0 bg-white shadow-md rounded-md w-40 p-2">
                                                    <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 1</button>
                                                    <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 2</button>
                                                    <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 3</button>
                                                </div>
                                            )}
                                        </div>
                                        {/* Go Live Button */}
                                        <div className="flex items-center justify-center">
                                            <button
                                                className={`px-8 py-2 rounded-full font-semibold
                                                ${isLive ? 'bg-[#BE1F2E] text-white font-semibold' : 'bg-blue-500 text-white px-8 py-2 rounded-full go-to-live-CTA'}`
                                                }
                                                onClick={handleGoLive}
                                            >
                                                {isLive ? "Stop" : "Go Live"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Right Sidebar */}
                    {/* Chat Section */}

                    <div className="golive-chatbox bg-[#F9FAFB] p-4 mb-5 h-[650px] relative">
                        <div className="absolute top-0 right-0 w-full h-[50%] z-10 bg-gradient-to-t from-[#ffffff00] to-[#ffffff] pointer-events-none" />

                        <div className="h-full overflow-y-auto space-y-4 relative scrollbar-hidden">
                            {/* White Shade Blur Effect */}

                            {chatMessages.map((chat) => (
                                <div className="">
                                    <div key={chat.id} className="p-3 rounded-md">
                                        {/* White Shade Blur Effect */}

                                        <div className="flex">
                                            <div className="">
                                                <img src={profileimg} className="w-9" />
                                            </div>
                                            <div className="pl-2">
                                                <p className="font-semibold">{chat.name}</p>
                                                <p className="text-[8px] text-[#000000]">{chat.time}</p>
                                            </div>
                                        </div>
                                        <p className="text-[12px] break-words pt-2">{chat.message}</p>
                                        <hr className="mt-2 pt-[1px] bg-[#D9D9D9]"></hr>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {/* Add Comment Input */}
                        <div className="flex items-center mt-4 w-full absolute bottom-2 right-0">
                            <div className="relative flex w-full mx-2">
                                <input
                                    type="text"
                                    placeholder="Add a comment"
                                    className="flex-1 p-3 border border-gray-300 rounded-full focus:outline-none"
                                />
                                <button className="bg-blue-500 text-white px-4 py-2 rounded-full go-to-live-CTA absolute right-1 top-1">
                                    Send
                                </button>
                            </div>
                            {/* Show Like Button only when live */}
                            {isLive && (
                                <button className="bg-[#BE1F2E] text-white px-3 mx-2 py-3 rounded-full">
                                    <img src={like} alt="Like" />
                                </button>
                            )}
                        </div>
                        {/* Footer */}
                        <div className="lg:hidden">
                            <div className="copy-rights pb-5 text-center text-sm text-[#095228]">
                                © 2025 Pipaan. All Rights Reserved
                            </div>
                        </div>
                    </div>
                </main>
            </main>
        </div >
    );
}
